import React from "react";
import { EmbeddedAppPage } from "./EmbeddedAppPage";
import { useInstalledPluginsFromStore } from "@/stores/globalStore";

export const XsitePage = () => {
    const xsitePlugin = useInstalledPluginsFromStore().find(
        (plugin) => plugin.abilities?.xolaFeature?.featureId === "xsite",
    );
    return <EmbeddedAppPage appId={xsitePlugin?.id ?? ""} />;
};
